// extracted by mini-css-extract-plugin
export var actionText = "_s6-4";
export var container = "_s6-0";
export var leftSection = "_s6-1";
export var rightSection = "_s6-2";
export var settingsButton = "_s6-6";
export var settingsIcon = "_s6-7";
export var shortcut = "_s6-5";
export var shortcutGroup = "_s6-3";